import React from 'react';
import { ShoppingCart, Smartphone, Shirt, Heart, Home, Monitor } from 'lucide-react';

const Services = () => {
  const productCategories = [
    {
      icon: Monitor,
      title: 'Electronics',
      description: 'Latest technology products, gadgets, and electronic devices from trusted manufacturers.'
    },
    {
      icon: Shirt,
      title: 'Fashion',
      description: 'Trendy clothing, accessories, and fashion items for all ages and styles.'
    },
    {
      icon: Heart,
      title: 'Health & Wellness',
      description: 'Health supplements, fitness equipment, and wellness products for a better lifestyle.'
    },
    {
      icon: Home,
      title: 'Home & Garden',
      description: 'Home improvement, furniture, garden supplies, and household essentials.'
    },
    {
      icon: Smartphone,
      title: 'Lifestyle',
      description: 'Lifestyle products, personal care items, and everyday essentials.'
    },
    {
      icon: ShoppingCart,
      title: 'Retail Solutions',
      description: 'Complete retail support and e-commerce solutions for businesses.'
    }
  ];

  const values = [
    {
      title: 'Reliability',
      description: 'Consistent, dependable service you can trust for all your trading needs.'
    },
    {
      title: 'Fast Delivery',
      description: 'Swift and secure delivery services ensuring your products reach you on time.'
    },
    {
      title: 'Customer-First',
      description: 'Your satisfaction is our priority. We go above and beyond for every client.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Product Categories */}
        

        

        {/* Our Values */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Core Values</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            The principles that guide everything we do and set us apart in the trading industry.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="text-center p-8 bg-white rounded-lg shadow-sm border border-gray-100"
            >
              <h4 className="text-2xl font-bold text-gray-900 mb-4">{value.title}</h4>
              <p className="text-gray-600 text-lg">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;